module.exports = __webpack_public_path__ + "img/gridview.d70d38d6.svg";